<template>
    <div>
        <kgr-dropdown
            display="name"
            :label="label"
            :options="filteredCategories"
            :value="value"
            :loading="loading"
            @post-input="onInput"
        />
    </div>
</template>

<script>
import Dropdown from './Dropdown.vue';
import OfferingCategoryRepository from '../../../../js/repository/club/offering/OfferingCategoryRepository';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            categories: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('categories');
        },
        filteredCategories() {
            return this.categories.filter((category) => this.excludedIds.indexOf(category.id) === -1);
        },
    },
    created() {
        OfferingCategoryRepository
            .findAll(this.clubId)
            .then((categories) => {
                this.categories = [];
                categories.forEach((category) => {
                    if (!category.isArchived) {
                        this.categories.push({
                            id: category.id,
                            name: category.name,
                            backgroundColor: category.backgroundColor,
                        },
                        );
                    }
                },
                );
                this.loading = false;
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
